module.exports = __webpack_public_path__ + "static/img/m_name.ee2aa78.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/xk/m_name.png
// module id = 4Ls1
// module chunks = 7